var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDb3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffef1",
      stroke: "none"
    },
    d: "M0 0L0 500L65 500L65 499C56.363 496.516 56.7953 485.526 55.9498 478C53.7365 458.296 50.6918 438.645 48 419C47.147 412.775 43.6022 401.738 47.7423 396.228C51.5991 391.094 61.252 391.668 67 390.87C84.6642 388.415 103.173 384.368 121 384C123.819 370.068 150.729 372.204 162 370.572C166.667 369.896 172.487 367.803 176.956 370.179C181.134 372.4 181.906 376.83 183 381C193.934 378.409 203.763 371.919 215 370.3C223.676 369.05 233.754 372.652 242 370.362C264.985 363.979 304.197 329.578 319.236 367C321.191 371.864 321 376.859 321 382C340.736 376.314 360.435 360.539 378 350C385.895 345.263 395.29 337.577 405 338.108C420.443 338.952 432.24 356.92 424.583 371C420.559 378.398 412.285 383.884 406 389.271L368 421.87C332.887 452.09 296.321 458.981 252 466.414C233.723 469.479 214.506 474.205 196 475C196 493.963 180.375 492.309 165 494.155C158.147 494.978 149.871 497.685 143.001 496.732C137.865 496.02 135.502 490.899 129.996 491.189C108.607 492.315 87.4584 498.941 66 499L66 500L500 500L500 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M70 38L71 39L70 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M82 150C86.3182 159.26 96.8256 166.826 104 174C106.861 176.861 110.065 181.285 114 182.671C124.006 186.196 132.824 171.843 134 164C140.163 165.426 146.662 167.484 152 170.966C176.315 186.826 158.692 213.542 166.603 235C168.651 240.554 175.308 245.695 180 249C181.876 238.894 181 228.249 181 218C181 188.812 178.787 162.754 147 152C160.151 111.582 190.18 84.9569 230 72L220 59C194.276 67.3701 163.154 84.4567 151 110L150 110L150 99C166.041 96.4969 153.693 68.7654 148.215 61C134.23 41.174 113.447 38 91 38C85.07 38 75.4225 36.1879 70.1088 39.179C63.7854 42.7385 66 53.9491 66 60C66 72.5334 71.4168 79.5705 73.7222 91C75.9168 101.88 72.9553 112.173 77.0656 123C80.126 131.062 96.5633 146.153 82 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M110.667 38.3333L111.333 38.6667L110.667 38.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M363 38L364 39L363 38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d66589",
      stroke: "none"
    },
    d: "M366 110C355.91 98.3395 346.696 86.9707 334 77.9097C303.391 56.0648 254.961 44.5279 219 60C221.668 63.7882 225.489 69.0133 230 70.6829C234.589 72.3812 241.24 69.4192 246 69.0895C257.987 68.2594 270.218 68.3212 282 71.1304C323.693 81.0711 355.742 111.323 369 152C360.03 155.054 335.805 167.211 339.418 180C340.681 184.47 346.394 188.46 350 191C356.054 175.215 365.519 167.813 382 164C383.756 181.145 404.246 189.434 417.985 179.362C424.396 174.662 424.618 162.831 434 166.059C465.343 176.843 458 211.633 458 238L397 238C410.575 257.272 428.898 253 450 253C455.986 253 467.228 255.172 471.397 249.772C474.502 245.749 473 237.788 473 233C473 218.542 475.098 202.236 472.535 188C470.118 174.571 462.069 162.785 450 156.324C444.864 153.574 429.606 151.842 427.662 145.867C426.063 140.952 433.476 134.051 435.688 130C440.939 120.381 442.536 109.815 443 99C460.955 95.2007 442.396 62.1917 435.826 55.0146C420.783 38.5799 400.632 38 380 38C373.588 38 362.203 35.7594 359.009 43.0548C352.031 58.9969 362.492 75.4964 365.698 90C367.071 96.2134 366 103.648 366 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M402.667 38.3333L403.333 38.6667L402.667 38.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M116 39L117 40L116 39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M408 39L409 40L408 39M412 40L413 41L412 40z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M122 41L123 42L122 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M359 41L360 42L359 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M66 42L67 43L66 42M125 42L126 43L125 42M127 43L128 44L127 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M358 43L359 44L358 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M129 44L130 45L129 44M65 45L65 69L66 69L65 45z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M423 45L424 46L423 45M425 46L426 47L425 46z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M134 47L135 48L134 47z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M429 49L430 50L429 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M139 51L140 52L139 51M140 52L141 53L140 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffef1",
      stroke: "none"
    },
    d: "M81 53C81 60.7484 79.4854 70.1683 84.1335 76.9066C93.4179 90.3664 127.548 84 142 84C132.232 54.0301 108.281 53 81 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M105 53L105 54L109 54L105 53M250 53L250 54L257 54L250 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M257 53L258 54L257 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M258 53L258 54L266 54L258 53M373 53L374 54L373 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffef1",
      stroke: "none"
    },
    d: "M434 84C429.463 62.3112 410.558 53.0999 390 53.0008C386.084 52.9819 377.838 51.4662 374.603 54.0278C371.617 56.3929 372.959 63.7614 373.428 67C376.025 84.9279 390.443 84 405 84L434 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M397 53L397 54L401 54L397 53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M113 54L114 55L113 54M240.667 54.3333L241.333 54.6667L240.667 54.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M242.667 54.3333L243.333 54.6667L242.667 54.3333M271 54L271 55L274 55L271 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M274 54L275 55L274 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M405.667 54.3333L406.333 54.6667L405.667 54.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M143 55L144 56L143 55M234 55L235 56L234 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M235.667 55.3333L236.333 55.6667L235.667 55.3333M279.667 55.3333L280.333 55.6667L279.667 55.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M281 55L282 56L281 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M409 55L410 56L409 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M119 56L120 57L119 56M144 56L145 57L144 56M229 56L230 57L229 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M230.667 56.3333L231.333 56.6667L230.667 56.3333M284.667 56.3333L285.333 56.6667L284.667 56.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M121 57L122 58L121 57M225 57L226 58L225 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M226 57L227 58L226 57M289 57L290 58L289 57z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M290 57L291 58L290 57M123 58L124 59L123 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M222 58L223 59L222 58M293 58L294 59L293 58M438 58L439 59L438 58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M218 59L219 60L218 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M296 59L297 60L296 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M297 59L298 60L297 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M417 59L418 60L417 59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M439 59L440 60L439 59M126 60L127 61L126 60M215 60L216 61L215 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M299 60L300 61L299 60z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M148 61L149 62L148 61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M302 61L303 62L302 61M305 62L306 63L305 62M421 62L422 63L421 62M441 62L442 63L441 62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M207 63L208 64L207 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M422 63L423 64L422 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M205 64L206 65L205 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M310 64L311 65L310 64M423 64L424 65L423 64M312 65L313 66L312 65M424 65L425 66L424 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M443 65L444 66L443 65M151 66L152 67L151 66z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M314 66L315 67L314 66M425 66L426 67L425 66M316 67L317 68L316 67M373 67L374 68L373 67M444 67L445 68L444 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M152 68L153 69L152 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M255 68L255 69L261 69L255 68M318 68L319 69L318 68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M373 68L374 69L373 68M135 69L136 70L135 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M242 69L242 70L245 70L242 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M245 69L246 70L245 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffef1",
      stroke: "none"
    },
    d: "M147 152C179.684 163.129 181 190.597 181 220C181 233.513 185.54 253.19 167 254C171.065 262.874 180.381 271.552 189 276C189 256.512 191.646 239.791 209 227.774C214.568 223.918 231.777 221.686 234.392 215.722C237.19 209.342 225.394 198.134 223.066 192C218.727 180.572 220.951 169.509 218.725 158C216.748 147.771 212 141.076 212 130C212 124.168 210.249 114.939 214.434 110.228C219.723 104.274 233.783 107 241 107C268.596 107 310.009 126.051 303.771 160.999C302.956 165.566 298.702 167.12 297.148 171.129C293.565 180.371 294.854 189.836 289.535 199C286.964 203.431 279.108 210.021 281.608 215.722C284.263 221.777 301.408 223.786 307 227.789C324.085 240.019 327 256.49 327 276C335.671 271.508 344.508 262.671 349 254C330.352 253.601 335 233.378 335 220C335 190.472 336.263 163.147 369 152C363.79 136.016 356.092 120.618 344.826 108C298.086 55.6517 216.469 57.1497 170.174 109C159.12 121.38 152.084 136.376 147 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M270 69L271 70L270 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M271.667 69.3333L272.333 69.6667L271.667 69.3333M320 69L321 70L320 69M373.333 69.6667L373.667 70.3333L373.333 69.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M193 70L194 71L193 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M236.667 70.3333L237.333 70.6667L236.667 70.3333M278.667 70.3333L279.333 70.6667L278.667 70.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M322 70L323 71L322 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M358.333 70.6667L358.667 71.3333L358.333 70.6667M428 70L429 71L428 70z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M81 71L82 72L81 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M231.667 71.3333L232.333 71.6667L231.667 71.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M282 71L283 72L282 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M283 71L284 72L283 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M228 72L229 73L228 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M287 72L288 73L287 72M325 72L326 73L325 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M358 72L359 73L358 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M446 72L447 73L446 72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M154 73L155 74L154 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M290.667 73.3333L291.333 73.6667L290.667 73.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M327 73L328 74L327 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M374 73L375 74L374 73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M66 74L67 75L66 74M82 74L83 75L82 74M138 74L139 75L138 74z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M294 74L295 75L294 74M328 74L329 75L328 74M297 75L298 76L297 75M330 75L331 76L330 75M375 75L376 76L375 75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M155 76L156 77L155 76M216 76L217 77L216 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M299 76L300 77L299 76M359 76L360 77L359 76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M67 77L68 78L67 77M84 77L85 78L84 77M182 77L183 78L182 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M302 77L303 78L302 77M333 77L334 78L333 77z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M211 78L212 79L211 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M304 78L305 79L304 78M334 78L335 79L334 78M448 78L449 79L448 78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M140 79L141 80L140 79M209 79L210 80L209 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M306 79L307 80L306 79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M360 79L361 80L360 79M68 80L69 81L68 80M87 80L88 81L87 80M156 80L157 81L156 80M178 80L179 81L178 80M207 80L208 81L207 80M308 80L309 81L308 80M337 80L338 81L337 80M88 81L89 82L88 81M310 81L311 82L310 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M338 81L339 82L338 81M361 81L362 82L361 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M381 81L382 82L381 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M433 81L434 82L433 81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M69 82L70 83L69 82M90 82L91 83L90 82M141 82L142 83L141 82M312 82L313 83L312 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M449.333 82.6667L449.667 83.3333L449.333 82.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M93 83L94 84L93 83M201 83L202 84L201 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M314 83L315 84L314 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M362 83L363 84L362 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M385 83L386 84L385 83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M98 84L98 85L118 85L98 84M173 84L174 85L173 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M391 84L391 85L405 85L391 84z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M71 85L72 86L71 85M157.333 85.6667L157.667 86.3333L157.333 85.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M343 85L344 86L343 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M196 86L197 87L196 86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M319 86L320 87L319 86M344 86L345 87L344 86M345 87L346 88L345 87M365 87L366 88L365 87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M73 88L73 110L74 110L73 88M193 88L194 89L193 88z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M322 88L323 89L322 88M346 88L347 89L346 88M325 90L326 91L325 90z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M157 93L158 94L157 93M186 93L187 94L186 93z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M329 93L330 94L329 93M330 94L331 95L330 94M353 95L354 96L353 95M354 96L355 97L354 96M448 96L449 97L448 96M334 97L335 98L334 97M355 97L356 98L355 97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M88 98L88 108L89 108L88 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffef1",
      stroke: "none"
    },
    d: "M89 98C89 111.625 92.8998 136.022 111 137.617C128.042 139.12 134.898 112.3 135 100L89 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M90 98L91 99L90 98M180 98L181 99L180 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M335 98L336 99L335 98M356 98L357 99L356 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffef1",
      stroke: "none"
    },
    d: "M381 98C381 111.773 385.595 135.24 403 137.501C420.566 139.782 427 112.245 427 100L381 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M382 98L383 99L382 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M383 98L384 99L383 98M446 98L447 99L446 98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M95 99L95 100L135 100C124.488 95.589 106.434 99 95 99M150 99L151 100L150 99M158 99L159 100L158 99M179 99L180 100L179 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M336 99L337 100L336 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M357 99L358 100L357 99M388 99L388 100L405 100L388 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M405 99L405 100L427 100L405 99M443 99L444 100L443 99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M157 100L158 101L157 100M178 100L179 101L178 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M337 100L338 101L337 100z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M177 101L178 102L177 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M338 101L339 102L338 101z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M176 102L177 103L176 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M339 102L340 103L339 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M175 103L176 104L175 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M340 103L341 104L340 103M360 103L361 104L360 103z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M174 104L175 105L174 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M341 104L342 105L341 104M361 104L362 105L361 104M442 104L442 109L443 109L442 104z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M153 105L154 106L153 105M173 105L174 106L173 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M342 105L343 106L342 105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M172 106L173 107L172 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M343 106L344 107L343 106z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M134 107L134 110L135 110L134 107M217 107L218 108L217 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M204 273C204 248.836 214.382 242.128 235 233C242.509 258.895 273.492 258.893 281 233C286.259 235.331 292.098 236.465 297 239.559C313.68 250.089 312 267.77 312 285C312 290.016 314.404 303.821 309.682 306.972C305.261 309.923 295.148 308 290 308L239 308C253.126 328.053 278.039 322 300 322C306.206 322 318.252 324.296 323.606 320.821C331.487 315.705 323.732 301.975 328.603 295.184C335.745 285.23 349.386 278.688 357.561 269C361.368 264.488 365.361 255.804 371.04 253.603C381.593 249.514 399.677 253 411 253C407.509 248.044 401.856 240.762 396 238.603C383.682 234.062 363.147 238 350 238L351 190L338 180C331.57 195.139 335 215.828 335 232C335 237.208 333.486 245.402 336.742 249.852C339.748 253.958 345.541 253 350 253L327 276C327 245.312 313.575 222.811 281 218C281.119 207.904 289.965 200.425 293.301 191C295.503 184.778 294.127 176.942 296.603 171.213C299.628 164.215 304.924 164.368 303.711 155C301.904 141.06 293.547 134.547 284 125C280.222 121.222 274.564 117.219 273 112C269.386 112.129 264.842 109.134 261 108.333C250.462 106.138 225.768 103.07 216 108.167C209.569 111.522 212 122.87 212 129C212 135.885 211.71 142.488 214.333 149C215.836 152.73 219.441 155.975 220 160C221.595 171.482 218.816 181.783 223.333 193C225.61 198.654 235.552 208.403 235 214C234.414 219.949 221.522 221.031 217 223.167C196.772 232.719 178.143 258.03 204 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M253 107L253 108L256 108L253 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M363 107L364 108L363 107z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M151 108L152 109L151 108M215 108L216 109L215 108M261 108L262 109L261 108M364 108L365 109L364 108M265 109L266 110L265 109M381 109L382 110L381 109M268 110L269 111L268 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M381 110L382 111L381 110z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M347 111L348 112L347 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M426 111L427 112L426 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M89.3333 112.667L89.6667 113.333L89.3333 112.667M167 112L168 113L167 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d66589",
      stroke: "none"
    },
    d: "M271 112L272 113L271 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M348 112L349 113L348 112z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d66589",
      stroke: "none"
    },
    d: "M272 113L299 140C295.24 128.123 284.007 116.533 272 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M274 113L275 114L274 113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M275 113L276 114L275 113M74.3333 114.667L74.6667 115.333L74.3333 114.667M133 114L134 115L133 114z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M276 114L277 115L276 114M382 114L383 115L382 114M441 114L442 115L441 114M278 115L279 116L278 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M350 115L351 116L350 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M425 115L426 116L425 115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M90 116L91 117L90 116M164 116L165 117L164 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M279 116L280 117L279 116M351 116L352 117L351 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M132 117L133 118L132 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M281 117L282 118L281 117M383 117L384 118L383 117z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M75.3333 118.667L75.6667 119.333L75.3333 118.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M282 118L283 119L282 118M424 118L425 119L424 118M440 118L441 119L440 118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M91 119L92 120L91 119M131 119L132 120L131 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M353 119L354 120L353 119z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M285 120L286 121L285 120M423 120L424 121L423 120M76 121L77 122L76 121M92 121L93 122L92 121M130 121L131 122L130 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M286 121L287 122L286 121M439 121L440 122L439 121z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M93 122L94 123L93 122M160 122L161 123L160 122M227 122L227 123L250 123L227 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M287 122L288 123L287 122M355 122L356 123L355 122M422 122L423 123L422 122z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M129 123L130 124L129 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffef1",
      stroke: "none"
    },
    d: "M227 123C227 130.439 225.744 139.396 230.144 145.907C234.891 152.93 242.409 153 250 153L288 153C279.089 122.268 253.644 123 227 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M258 123L259 124L258 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M288 123L289 124L288 123z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M77 124L78 125L77 124M94 124L95 125L94 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M289 124L290 125L289 124M438 124L439 125L438 124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M158 125L159 126L158 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M290 125L291 126L290 125M357 125L358 126L357 125M387 125L388 126L387 125z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M420 125L421 126L420 125M78 126L79 127L78 126M127 126L128 127L127 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M388 126L389 127L388 126M437 126L438 127L437 126z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M96 127L97 128L96 127M157 127L158 128L157 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M358 127L359 128L358 127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M79 128L80 129L79 128M97 128L98 129L97 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M292 128L293 129L292 128M436 128L437 129L436 128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M98 129L99 130L98 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M293 129L294 130L293 129z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M359 129L360 130L359 129M80 130L81 131L80 130M99 130L100 131L99 130M273 130L274 131L273 130M294 130L295 131L294 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M416 130L417 131L416 130M435 130L436 131L435 130z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M100 131L101 132L100 131M360 131L361 132L360 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M415 131L416 132L415 131z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M81 132L82 133L81 132M101 132L102 133L101 132M154 132L155 133L154 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M295 132L296 133L295 132z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M82 133L83 134L82 133M102 133L103 134L102 133M120 133L121 134L120 133M395 133L396 134L395 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M433 133L434 134L433 133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M119 134L120 135L119 134M153 134L154 135L153 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M296 134L297 135L296 134M396 134L397 135L396 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M105 135L106 136L105 135M117 135L118 136L117 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M297 135L298 136L297 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M362 135L363 136L362 135M84 136L85 137L84 136M107 136L108 137L107 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M399 136L400 137L399 136M408 136L409 137L408 136M431 136L432 137L431 136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M85 137L86 138L85 137M114 137L115 138L114 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M298 137L299 138L298 137M363 137L364 138L363 137M401 137L402 138L401 137M406 137L407 138L406 137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M86 138L87 139L86 138M87 139L88 140L87 139M151 139L152 140L151 139M227 139L228 140L227 139M299 139L300 140L299 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M364 139L365 140L364 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M88 141L88 148L89 148L88 141M150 141L151 142L150 141M212 142L213 143L212 142M365 142L366 143L365 142M284 143L285 144L284 143M149 144L150 145L149 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M366 144L367 145L366 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M213 146L214 147L213 146M230 146L231 147L230 146M148 147L149 148L148 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M367 147L368 148L367 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M87 148L88 149L87 148M302 148L303 149L302 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M428 148L429 149L428 148z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M84 149L85 150L84 149M233 149L234 150L233 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M431 149L432 150L431 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M321 323L321 322L275 322L254 321.397L239 308L311 308L311 307L204 307L203.397 274L190 256L189 256L189 276L167 254L180 250L180 249C175.791 244.791 169.718 240.38 167.028 235C161.777 224.498 166 202.723 166 191L165 191L165 238L58 238C58 217.435 51.704 186.806 70.0008 172.39C75.4711 168.081 82.4813 166.121 89 164C90.9881 177.264 101.236 183.965 114 184L82 150C75.8988 151.985 69.5046 153.692 64 157.069C40.0422 171.763 43 196.621 43 221C43 227.826 39.6247 247.783 46.2284 251.821C52.0183 255.361 64.3804 253 71 253C88.0186 253 105.056 253.918 122 253.999C128.823 254.032 139.46 251.848 145.819 254.6C150.709 256.717 153.941 264.06 157.299 268C162.94 274.618 169.187 280.918 176 286.334C179.686 289.264 185.599 292.007 187.972 296.184C191.926 303.142 184.722 315.908 192.148 321.142C199.866 326.581 218.836 323 228 323L321 323M147 150L148 151L147 150M234 150L235 151L234 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M368 150L369 151L368 150M434 150L435 151L434 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M236 151L237 152L236 151M287 151L288 152L287 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M437 151L438 152L437 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffef1",
      stroke: "none"
    },
    d: "M104 152C104 155.911 103.101 161.285 105.179 164.786C108.276 170.003 115.964 169.585 118.258 163.956C119.701 160.415 119 155.75 119 152L104 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M106 152L107 153L106 152M116.667 152.333L117.333 152.667L116.667 152.333M119 152L119 163L120 163L119 152M148 152L149 153L148 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M367 152L368 153L367 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M396 152L396 162L397 162L396 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffef1",
      stroke: "none"
    },
    d: "M397 152C397 155.9 396.047 161.374 398.028 164.891C400.811 169.833 407.743 169.503 410.543 164.786C412.715 161.128 412 156.075 412 152L397 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M398.667 152.333L399.333 152.667L398.667 152.333M409 152L410 153L409 152M440 152L441 153L440 152z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M151 153L152 154L151 153M244 153L244 154L288 154C276.537 149.19 256.48 153 244 153M303 153L304 154L303 153M364 153L365 154L364 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M443 153L444 154L443 153z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M153 154L154 155L153 154M217 154L218 155L217 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M362 154L363 155L362 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M446 154L447 155L446 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M360 155L361 156L360 155M448 155L449 156L448 155M358 156L359 157L358 156z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M450 156L451 157L450 156M159 157L160 158L159 157M219 157L219 177L220 177L219 157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M356 157L357 158L356 157M453 158L454 159L453 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M162 159L163 160L162 159z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M353 159L354 160L353 159M457 161L458 162L457 161M396 162L397 163L396 162M348 163L349 164L348 163M411 163L412 164L411 163z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffef1",
      stroke: "none"
    },
    d: "M58 238L165 238C165 219.841 171.032 189.535 157.532 175.3C151.553 168.995 143.008 166.606 135 164C125.907 186.814 95.6719 192.076 89 164C82.1339 165.588 74.5952 167.948 69.0039 172.39C51.5101 186.29 58 218.271 58 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M104 164L105 165L104 164M118.333 164.667L118.667 165.333L118.333 164.667M134 164L135 165L134 164M136 164L137 165L136 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M347 164L348 165L347 164M379 164L380 165L379 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffef1",
      stroke: "none"
    },
    d: "M350 238L458 238C458 207.273 464.896 172.771 427 164C420.516 191.287 389.122 187.851 381 164C373.337 166.493 365.197 168.624 359.184 174.326C344.172 188.562 350 219.345 350 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M381 164L382 165L381 164M429 164L430 165L429 164z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M139 165L140 166L139 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M376 165L377 166L376 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M381 165L382 166L381 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M410 165L411 166L410 165M426.333 165.667L426.667 166.333L426.333 165.667M432 165L433 166L432 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M117 166L118 167L117 166M142 166L143 167L142 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M373 166L374 167L373 166M398 166L399 167L398 166M435 166L436 167L435 166M462 166L463 167L462 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M107 167L108 168L107 167M116 167L117 168L116 167M133.333 167.667L133.667 168.333L133.333 167.667M145 167L146 168L145 167M235 167L236 168L235 167M300 167L301 168L300 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M370 167L371 168L370 167M399 167L400 168L399 167M408 167L409 168L408 167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M437 167L438 168L437 167M463 167L464 168L463 167M108.667 168.333L109.333 168.667L108.667 168.333M114 168L115 169L114 168M147 168L148 169L147 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffef1",
      stroke: "none"
    },
    d: "M235 168C235 181.335 239.806 205.057 257 206.721C274.533 208.417 280.999 181.529 281 169L235 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M240.667 168.333L241.333 168.667L240.667 168.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M344 168L345 169L344 168M367 168L368 169L367 168M382 168L383 169L382 168M401 168L402 169L401 168M406 168L407 169L406 168M440 168L441 169L440 168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M172 169L173 170L172 169M296 169L296 174L297 174L296 169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M343 169L344 170L343 169M365 169L366 170L365 169M425 169L426 170L425 169M442 169L443 170L442 169z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M132 170L133 171L132 170M151 170L152 171L151 170M364 170L365 171L364 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M383 170L384 171L383 170M465 170L466 171L465 170z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M153 171L154 172L153 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M342 171L343 172L342 171M362 171L363 172L362 171M424 171L425 172L424 171z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M445 171L446 172L445 171M131 172L132 173L131 172M154 172L155 173L154 172M174 172L175 173L174 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M341 172L342 173L341 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M361 172L362 173L361 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M384 172L385 173L384 172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M155 173L156 174L155 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M423 173L424 174L423 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M467 173L468 174L467 173M175 174L176 175L175 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M340 174L341 175L340 174M358 174L359 175L358 174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M385 174L386 175L385 174M129 175L130 176L129 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M386 175L387 176L386 175M468 175L469 176L468 175z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M128 176L129 177L128 176M158 176L159 177L158 176M176 176L177 177L176 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M339 176L340 177L339 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M127 177L128 178L127 177M159 177L160 178L159 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M356 177L357 178L356 177M469 177L470 178L469 177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M126 178L127 179L126 178M177 178L178 179L177 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M338 178L339 179L338 178M355 178L356 179L355 178M389 178L390 179L389 178z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M452 178L453 179L452 178M125 179L126 180L125 179M280 179L281 180L280 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M390 179L391 180L390 179z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M123 180L124 181L123 180M161 180L162 181L161 180M235 180L236 181L235 180M354 180L355 181L354 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M416 180L417 181L416 180M470 180L471 181L470 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M121.667 181.333L122.333 181.667L121.667 181.333M178 181L179 182L178 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M353 181L354 182L353 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M393 181L394 182L393 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M414 181L415 182L414 181M454 181L455 182L454 181z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M119 182L120 183L119 182M162 182L163 183L162 182M295.333 182.667L295.667 183.333L295.333 182.667M395 182L396 183L395 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M396 182L397 183L396 182M412 182L413 183L412 182z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M115.667 183.333L116.333 183.667L115.667 183.333M220 183L221 184L220 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M352 183L353 184L352 183M399.667 183.333L400.333 183.667L399.667 183.333M408 183L409 184L408 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M409 183L410 184L409 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M455 183L456 184L455 183M471 183L472 184L471 183z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M163 184L164 185L163 184M179.333 184.667L179.667 185.333L179.333 184.667M236 184L237 185L236 184M352 184L353 185L352 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M351 186L352 187L351 186z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M164 187L165 188L164 187M221 187L222 188L221 187M237 187L238 188L237 187M294 187L295 188L294 187M351 187L352 188L351 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M472 187L473 188L472 187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M335 188L336 189L335 188M180 189L180 193L181 193L180 189M238 189L239 190L238 189M277 189L278 190L277 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M457 189L458 190L457 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M222 190L223 191L222 190M293 190L294 191L293 190M239 191L240 192L239 191M350 191L350 194L351 194L350 191M223 193L224 194L223 193M240 193L241 194L240 193M274 194L275 195L274 194M224 195L225 196L224 195M291 195L292 196L291 195M225 197L226 198L225 197M243 197L244 198L243 197M290 197L291 198L290 197M244 198L245 199L244 198M226 199L227 200L226 199M245 199L246 200L245 199M270 199L271 200L270 199M289 199L290 200L289 199M246 200L247 201L246 200M269 200L270 201L269 200M227 201L228 202L227 201M247 201L248 202L247 201M251 204L252 205L251 204M264 204L265 205L264 204M230 205L231 206L230 205M262 205L263 206L262 205M285 205L286 206L285 205M281 217L282 218L281 217M284 218L285 219L284 218M287 219L288 220L287 219M290 220L291 221L290 220M250.667 221.333L251.333 221.667L250.667 221.333M264 221L265 233L266 233L264 221M293 221L294 222L293 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffef1",
      stroke: "none"
    },
    d: "M250 222C250.001 227.919 255.863 247.307 263.821 234.656C265.944 231.28 265 225.815 265 222L250 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M255 222L255 223L261 223L255 222M296 222L297 223L296 222M216 223L217 224L216 223M299 223L300 224L299 223M214 224L215 225L214 224M301 224L302 225L301 224M212 225L213 226L212 225M303 225L304 226L303 225M210 226L211 227L210 226M305 226L306 227L305 226M207 228L208 229L207 228M308 228L309 229L308 228M202 232L203 233L202 232M250 232L251 233L250 232M201 233L202 234L201 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffef1",
      stroke: "none"
    },
    d: "M234 233C226.881 236.155 219.026 237.796 213.184 243.326C197.983 257.715 204 288.072 204 307L312 307C312 288.132 317.851 257.836 302.7 243.468C296.777 237.851 288.574 235.464 281 233C276.448 248.693 259.995 259.301 245.039 248.895C239.121 244.777 237.611 238.71 234 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M235.333 234.667L235.667 235.333L235.333 234.667M251 234L252 235L251 234M264 234L265 235L264 234M280 234L281 235L280 234M224 236L225 237L224 236M262 236L263 237L262 236M222 237L223 238L222 237M254 237L255 238L254 237M293 237L294 238L293 237M197 238L198 239L197 238M236 238L237 239L236 238M279 238L280 239L279 238M295 238L296 239L295 238M318 238L319 239L318 238M218 239L219 240L218 239M297 239L298 240L297 239M216 240L217 241L216 240M237 240L238 241L237 240M278 240L279 241L278 240M195 241L196 242L195 241M215 241L216 242L215 241M320 241L321 242L320 241M238 242L239 243L238 242M277 242L278 243L277 242M301 242L302 243L301 242M194 243L195 244L194 243M193 245L194 246L193 245M304 245L305 246L304 245M180.333 246.667L180.667 247.333L180.333 246.667M210 246L211 247L210 246M241 246L242 247L241 246M192 247L193 248L192 247M209 247L210 248L209 247M242 247L243 248L242 247M323 247L324 248L323 247M335 248L336 249L335 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M43 249L44 250L43 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M191.333 249.667L191.667 250.333L191.333 249.667M208 249L209 250L208 249M245 249L246 250L245 249M270 249L271 250L270 249M307 249L308 250L307 249M207 250L208 251L207 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M471 250L472 251L471 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M266 251L267 252L266 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M470 251L471 252L470 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M46 252L47 253L46 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M190.333 252.667L190.667 253.333L190.333 252.667M206 252L207 253L206 252M251.667 252.333L252.333 252.667L251.667 252.333M263 252L264 253L263 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M468 252L469 253L468 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M50 253L50 254L61 254L50 253M65 253L65 254L81 254L65 253M90 253L90 254L100 254L90 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M257.667 253.333L258.333 253.667L257.667 253.333M309 253L310 254L309 253M325 253L326 254L325 253M342 253L342 254L350 254L342 253M369 253L369 254L466 254L436 253L369 253M205.333 254.667L205.667 255.333L205.333 254.667M348 255L349 256L348 255M310 256L311 257L310 256M326 257L327 258L326 257M204.333 258.667L204.667 259.333L204.333 258.667M311.333 260.667L311.667 261.333L311.333 260.667M344 260L345 261L344 260M343 261L344 262L343 261M342 262L343 263L342 262M362 262L363 263L362 262M358 267L359 268L358 267M335 269L336 270L335 269M334 270L335 271L334 270M333 271L334 272L333 271M328 275L329 276L328 275M342 283L343 284L342 283M341 284L342 285L341 284M336 288L337 289L336 288M326 317L327 318L326 317M325 319L326 320L325 319M323 321L324 322L323 321M399.667 338.333L400.333 338.667L399.667 338.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#bf76d0",
      stroke: "none"
    },
    d: "M320 383C322.893 360.089 305.246 344.948 283 352C288.268 359.479 295.33 361.837 301.671 367.558C307.487 372.805 311.167 381.169 317 387C320.451 390.45 324.465 396.247 330 394.833C349.453 389.864 369.604 372.198 387 362.281C392.599 359.089 402.289 350.256 408.656 355.657C417.668 363.301 402.117 372.464 397 376.87C385.316 386.929 373.502 396.9 362 407.166C359.064 409.786 351.207 414.628 351.207 419.004C351.206 422.802 356.569 426.567 359 429C374.295 418.883 388.067 405.196 402 393.271C409.09 387.202 418.94 381.105 423.775 372.999C432.619 358.174 421.694 337.694 404 338.13C393.637 338.386 384.548 345.968 376 350.989C357.825 361.665 339.635 375.263 320 383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M408 338L409 339L408 338M396 339L397 340L396 339M411 339L412 340L411 339M414 340L415 341L414 340M390 342L391 343L390 342M388 343L389 344L388 343M385 345L386 346L385 345M383 346L384 347L383 346M380 348L381 349L380 348M290 349L290 350L298 350L290 349M378 349L379 350L378 349M286.667 350.333L287.333 350.667L286.667 350.333M301 350L302 351L301 350M424 350L425 351L424 350M283.667 351.333L284.333 351.667L283.667 351.333M304 351L305 352L304 351M375 351L376 352L375 351M183 381L177.891 370.179L165 370.05L126.105 376.008L115 385L140 410L137 389L168 385C170.461 416.18 171.374 455.082 202 472.307C205.578 474.32 210.204 472.664 214 472.13C223.349 470.816 232.651 469.184 242 467.87C273.208 463.481 305.097 460.027 334 446.691C343.508 442.303 351.352 435.715 360 430C355.913 424.198 349.956 421.304 354 414C335.885 426.387 319.67 437.511 298 443.244C263.953 452.25 226.56 450.388 193 461C191.758 445.268 188.377 429.725 187 414C186.629 409.761 183.872 402.15 186.067 398.275C189.321 392.531 204.976 389.142 211 387.079C222.398 383.175 233.289 389.299 244 386.366C261.667 381.528 278.365 365.438 297 365L282 352.994L270 357.309L241 370.348L215 370.174L183 381M306 352L307 353L306 352M373 352L374 353L373 352M425 352L426 353L425 352M308 353L309 354L308 353M402 353L402 354L406 354L402 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffef1",
      stroke: "none"
    },
    d: "M193 460C212.048 458.497 231.093 454.057 250 451.272C277.83 447.172 305.668 443.841 331 430.742C344.84 423.585 356.236 412.444 368 402.421C380.051 392.154 391.898 381.643 403.996 371.435C408.209 367.88 415.076 362.042 409.566 356.318C401.517 347.957 379.327 366.685 372 370.989C357.659 379.413 343.376 389.589 328 395.988C316.899 400.609 305.076 401.76 294 405.915C285.63 409.055 272.033 419.541 263.004 418.356C253.133 417.061 257.122 406.738 263.004 403.414C274.795 396.749 290.288 393.866 300.892 385.363C306.023 381.248 307.415 373.353 302.581 368.394C295.352 360.979 284.37 367.765 277 371.22C266.509 376.138 252.541 385.526 241 386.748C234.267 387.46 226.99 384.722 220 385.039C212.255 385.391 205.083 388.967 198 391.8C194.616 393.154 188.165 394.43 186.067 397.649C183.655 401.351 186.676 410.839 187.271 415C189.372 429.709 192.694 445.153 193 460z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M368 355L369 356L368 355M398 355L399 356L398 355M409 355L410 356L409 355M312 356L313 357L312 356M366 356L367 357L366 356M396 356L397 357L396 356M426 356L427 357L426 356M313 357L314 358L313 357M314 358L315 359L314 358M363 358L364 359L363 358M393 358L394 359L393 358M411 358L412 359L411 358M361 359L362 360L361 359M391 359L392 360L391 359M316 361L317 362L316 361M358 361L359 362L358 361M356 362L357 363L356 362M386 362L387 363L386 362M384 363L385 364L384 363M411 363L412 364L411 363M318.333 364.667L318.667 365.333L318.333 364.667M353 364L354 365L353 364M298.667 365.333L299.333 365.667L298.667 365.333M351 365L352 366L351 365M381 365L382 366L381 365M410 365L411 366L410 365M300 366L301 367L300 366M379 366L380 367L379 366M426 366L427 367L426 366M302 367L303 368L302 367M319.333 367.667L319.667 368.333L319.333 367.667M348 367L349 368L348 367M408 367L409 368L408 367M346 368L347 369L346 368M376 368L377 369L376 368z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M168.667 369.333L169.333 369.667L168.667 369.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M344 369L345 370L344 369M374 369L375 370L374 369M425 369L426 370L425 369M304 370L305 371L304 370M320 370L320 373L321 373L320 370z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M153.667 371.333L154.333 371.667L153.667 371.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M341 371L342 372L341 371M371 371L372 372L371 371M403 371L404 372L403 371z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M146.667 372.333L147.333 372.667L146.667 372.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M305.333 372.667L305.667 373.333L305.333 372.667M339 372L340 373L339 372M369 372L370 373L369 372M402 372L403 373L402 372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M139.667 373.333L140.333 373.667L139.667 373.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M338 373L339 374L338 373M423 373L424 374L423 373z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M131 374L131 375L134 375L131 374M200 374L201 375L200 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M336 374L337 375L336 374z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M126 375L127 376L126 375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M334 375L335 376L334 375M364 375L365 376L364 375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M124 376L125 377L124 376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M306 376C301.144 389.894 282.173 393.867 270 399.742C265.566 401.881 259.618 403.322 257.183 408.043C254.015 414.184 259.891 419.749 266 418.375C276.061 416.112 285.365 409.53 295 405.915C305.218 402.081 316.557 400.533 327 397L306 376M333 376L334 377L333 376M362 376L363 377L362 376M331 377L332 378L331 377M396 377L397 378L396 377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M122 378L123 379L122 378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M329 378L330 379L329 378M359 378L360 379L359 378M395 378L396 379L395 378z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M182 379L183 380L182 379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M320 379L322 383L320 379M327 379L328 380L327 379M357 379L358 380L357 379z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M121 380L122 381L121 380z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M325.667 380.333L326.333 380.667L325.667 380.333M416 380L417 381L416 380M323 381L324 382L323 381M354 381L355 382L354 381M352 382L353 383L352 382M350 383L351 384L350 383z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M196 475L203 474L176 447L180 477L150 481L143 432L140 411L129 399L118 385C112.538 383.041 104.665 385.734 99 386.573C87.0283 388.345 74.9786 389.559 63 391.271C57.9148 391.997 49.1662 391.463 46.7423 397.109C44.4484 402.452 46.6465 410.481 47.4244 416C49.2556 428.993 50.8737 442.014 52.7292 455C54.1561 464.987 55.3017 475.014 56.7292 485C57.2919 488.937 57.2547 494.55 60.4329 497.432C64.9291 501.51 74.6358 498.552 80 497.95C95.3582 496.225 116.798 488.601 131.961 491.407C135.854 492.127 137.965 496.073 142.004 496.768C153.403 498.728 168.566 493.785 180 492.282C184.402 491.703 190.273 491.895 193.682 488.567C197.063 485.268 196 479.291 196 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M349 384L350 385L349 384M388 384L389 385L388 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M164.667 385.333L165.333 385.667L164.667 385.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffef1",
      stroke: "none"
    },
    d: "M137 389L150 481L180 477L168 385L137 389z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M347 385L348 386L347 385M387 385L388 386L387 385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M155 386L155 387L158 387L155 386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M345 386L346 387L345 386M409 386L410 387L409 386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M148 387L148 388L151 388L148 387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M408 387L409 388L408 387z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M140 388L140 389L143 389L140 388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M342 388L343 389L342 388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M168.333 389.667L168.667 390.333L168.333 389.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M340 389L341 390L340 389M338 390L339 391L338 390M381 390L382 391L381 390z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M137 391L137 394L138 394L137 391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M336.667 391.333L337.333 391.667L336.667 391.333M380 391L381 392L380 391z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M196 392L197 393L196 392z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M335 392L336 393L335 392M379 392L380 393L379 392M402 392L403 393L402 392M333 393L334 394L333 393M401 393L402 394L401 393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M191 394L192 395L191 394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M331 394L332 395L331 394M328.667 395.333L329.333 395.667L328.667 395.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M186 396L187 397L186 396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M374 396L375 397L374 396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M169.333 397.667L169.667 398.333L169.333 397.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M373 397L374 398L373 397z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M138 398L138 402L139 402L138 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M372 398L373 399L372 398M395 398L396 399L395 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffef1",
      stroke: "none"
    },
    d: "M62 407L72 483L133 475L123 399L62 407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M394 399L395 400L394 399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M185.333 401.667L185.667 402.333L185.333 401.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M367 402L368 403L367 402z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M170 403L170 406L171 406L170 403z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M366 403L367 404L366 403M389 403L390 404L389 403M365 404L366 405L365 404M388 404L389 405L388 404M387 405L388 406L387 405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M139 406L139 409L140 409L139 406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M360 408L361 409L360 408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M186 409L187 410L186 409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M359 409L360 410L359 409M382 409L383 410L382 409M358 410L359 411L358 410M381 410L382 411L381 410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M171 411L171 414L172 414L171 411z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M357 411L358 412L357 411M380 411L381 412L380 411M356 412L357 413L356 412M376 414L377 415L376 414M375 415L376 416L375 415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M187 416L187 419L188 419L187 416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M374 416L375 417L374 416M373 417L374 418L373 417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M172 418L172 421L173 421L172 418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M370 419L371 420L370 419M369 420L370 421L369 420M368 421L369 422L368 421M367 422L368 423L367 422M366 423L367 424L366 423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M188 424L188 427L189 427L188 424M173 425L173 429L174 429L173 425z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9990e6",
      stroke: "none"
    },
    d: "M363 425L364 426L363 425M362 426L363 427L362 426M361 427L362 428L361 427M360 428L361 429L360 428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6fb6e5",
      stroke: "none"
    },
    d: "M189 431L189 434L190 434L189 431M174 433L174 436L175 436L174 433M190 439L190 442L191 442L190 439M175 440L175 444L176 444L175 440M191 446L191 449L192 449L191 446M273 447L274 448L273 447M266 448L267 449L266 448M248 451L249 452L248 451M242 452L243 453L242 452M192 453L192 457L193 457L192 453M235 453L236 454L235 453M229 454L230 455L229 454M222 455L222 456L225 456L222 455M216 456L216 457L219 457L216 456M210 457L210 458L213 458L210 457M204.667 458.333L205.333 458.667L204.667 458.333M197 459L197 460L200 460L197 459M193 460L194 461L193 460M282 461L283 462L282 461M276 462L277 463L276 462M270 463L271 464L270 463M263.667 464.333L264.333 464.667L263.667 464.333M257 465L258 466L257 465M250.667 466.333L251.333 466.667L250.667 466.333M244.667 467.333L245.333 467.667L244.667 467.333M237.667 468.333L238.333 468.667L237.667 468.333M231.667 469.333L232.333 469.667L231.667 469.333M224 470L224 471L227 471L224 470M218 471L218 472L221 472L218 471M211 472L211 473L214 473L211 472M205 473L205 474L208 474L205 473z"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDb3);
export default __webpack_public_path__ + "static/media/db3.4bda76aa58f6f0e268fc2508f7a0e469.svg";
export { ForwardRef as ReactComponent };